// extracted by mini-css-extract-plugin
export default {"root":"ResetUserPasswordModal_root__0KJaa","container":"ResetUserPasswordModal_container__i-qD1"};